// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1ufch","Container":"Footer_Container__1glR2","title":"Footer_title__1O9Tx"};